import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useEffect } from 'react';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';

export const MESSAGES_PER_PAGE = 100;

export const useGetMessagesForCurrentConversation = () => {
  const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
    chatService: true,
  });

  const getChatMessages = (
    chatId: string,
    page: number = 1,
    limit: number = MESSAGES_PER_PAGE,
    successFunction: any
  ) => {
    send(
      {},
      `/api/v1/message/conversation/${chatId}?limit=${limit}&page=${page}&order[createdAt]=asc`
    ).then((res) => {
      return successFunction();
    });
  };

  useEffect(() => {
    if (!isLoading && !error && data) {
      if (globalUpdate) globalUpdate({ messages: data?.data });
    }
  }, [data, error, isLoading]);

  return {
    getChatMessages,
    data,
    isLoading,
    error,
  };
};
